export default {
  byBpId: {},
}

export const initialBpState = {
  article: null,
  status: 'idle', // idle | loading | ready | regenerating | failed
  lastFetchedAt: null,
  refreshInFlight: false,
  refreshNextAllowedAt: null,
  error: null,
}
